import { getCustomerBusinessDetails } from "Hooks/Api/apiCustomer";
import { CustomerEntity } from "Models/Entities";
import { BuildGenerateCreditReportDataFromCustomer, FillInitialGenerateCreditReportDataForCustomer } from "Views/Components/CreditReport/CreditReportList";
import EntityList from "Views/Components/EntityList/EntityList";

type Props = {
	customers: CustomerEntity[];
	totalCount: number;
}

export const BoardAsExistingCustomerSection: React.FunctionComponent<Props> = ({
	customers,
	totalCount
}) => {

	const handleGenerateCreditReport = async (customer: CustomerEntity) => {
		try {
			const reqCustomerBusinessDetail = await getCustomerBusinessDetails(customer.id);
			
			const data: BuildGenerateCreditReportDataFromCustomer = {
				customerId: customer.id,
				abnAcnDetail: reqCustomerBusinessDetail.data.abnAcnDetail,
				trusteeDetail: reqCustomerBusinessDetail.data.trusteeDetail,
				organisationId: customer.businessEntity.organisation.id,
				businessEntityId: customer.businessEntity.id,
				businessEntityName: customer.businessEntity.name,
				accountType: customer.businessEntity.organisation.accountType,
			};

			const stateKey = "generateCreditReportState";
			sessionStorage.setItem(stateKey, JSON.stringify({
				initialGenerateCreditReportData: FillInitialGenerateCreditReportDataForCustomer(data),
				stage: "provider",
			}));

			window.open(`/hub/credit-reports/generate`, "_blank");
		} catch (error) {
			console.error("Error generating credit report:", error);
			alert("Failed to generate credit report for this customer. Please try again later.");
		}
	}

	return (
		<div className="director-board-table">
			<h6>Available Customer(s)</h6>
			<EntityList
				collection={customers}
				columns={[
					{
						displayName: "Business Name",
						columnName: "businessName",
						value: (customer: CustomerEntity) => customer.businessName,
					},
					{
						displayName: "ABN",
						columnName: "abn",
						value: (customer: CustomerEntity) => customer.abn,
					},
					{
						displayName: "ACN",
						columnName: "acn",
						value: (customer: CustomerEntity) => customer.acn ?? "-",
					},
					{
						displayName: "Generate Credit Report",
						columnName: "generateCreditReport",
						value: () => (<span className="link-item">Credit Report</span>),
						className: "link",
						onClickValue: (handleGenerateCreditReport),
					},
					{
						displayName: "View Customer",
						columnName: "viewCustomer",
						value: () => (<span className="link-item">View</span>),
						className: "link",
						onClickValue: (customer: CustomerEntity) => {
							window.open(`/monitor/customers/${customer.id}`, "_blank");
						}
					}
				]}
				idColumn="id"
				sortColumn="name"
				sortDescending
			/>
		</div>
	)
}